<svg xmlns="http://wwww3.org/2000/svg" viewBox="0 0 496 512" class="sad-face-icon">
  <path
    d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
  />
</svg>
<h3>{{ 'accessDenied.title' | translate }}</h3>
<h3>{{ 'accessDenied.adminContact' | translate }}</h3>
